import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import config from './config'

Vue.use(BootstrapVue, config)
Vue.use(BootstrapVueIcons)
